/*
 * Listagem da versão curva (coleção e busca): filtros, ordenação e "Ver mais" sem recarregar.
 * Sem JS tudo funciona por links/formulários normais.
 */
(function () {
  if (window.__plentyListing) return;
  window.__plentyListing = true;

  function root() { return document.querySelector('[data-pl]'); }

  function sectionUrl(url, id) {
    var u = new URL(url, location.origin);
    u.searchParams.set('section_id', id);
    return u.toString();
  }

  function fetchSection(url) {
    var r = root();
    return fetch(sectionUrl(url, r.dataset.section), { headers: { Accept: 'text/html' } })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.querySelector('[data-pl]');
      });
  }

  function replace(url, push) {
    var r = root();
    if (!r) { location.href = url; return; }
    r.setAttribute('aria-busy', 'true');
    r.classList.add('is-loading');
    fetchSection(url)
      .then(function (fresh) {
        if (!fresh) { location.href = url; return; }
        var open = r.querySelector('details[open] summary');
        var wasDocked = docked();
        if (wasDocked) { dock.querySelector('.pf__row').remove(); hold = null; dock.classList.remove('is-on'); document.documentElement.classList.remove('pl-docked'); }
        r.replaceWith(fresh);
        fresh.classList.add('is-in');
        if (wasDocked) dockSync();
        if (push) history.pushState({ pl: 1 }, '', url);
        var top = fresh.querySelector('.pf');
        if (top && top.getBoundingClientRect().top < 0) {
          window.scrollTo({ top: window.scrollY + top.getBoundingClientRect().top - 70, behavior: 'smooth' });
        }
      })
      .catch(function () { location.href = url; });
  }

  function more(btn) {
    if (btn.__busy) return;
    btn.__busy = true;
    btn.classList.add('is-busy');
    btn.textContent = 'Carregando…';
    var r = root();
    var grid = r.querySelector('[data-pl-grid]');
    fetchSection(btn.href)
      .then(function (fresh) {
        if (!fresh) { location.href = btn.href; return; }
        var dedupe = r.hasAttribute('data-dedupe');
        var have = {};
        if (dedupe) grid.querySelectorAll('[data-base]').forEach(function (c) { have[c.dataset.base] = 1; });
        var i = 0;
        fresh.querySelectorAll('[data-pl-grid] > *').forEach(function (c) {
          if (dedupe && c.dataset.base && have[c.dataset.base]) return;
          if (c.classList.contains('pl__empty')) return;
          c.style.animationDelay = Math.min(i, 8) * 40 + 'ms';
          c.classList.add('pc-in');
          grid.appendChild(c);
          i++;
        });
        var wrap = r.querySelector('.pl__more');
        var nextWrap = fresh.querySelector('.pl__more');
        if (wrap) {
          if (nextWrap) wrap.replaceWith(nextWrap);
          else wrap.remove();
        }
      })
      .catch(function () { location.href = btn.href; });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var sm = t.closest('[data-pl] details[data-pf-d] > summary, .pf-dock details[data-pf-d] > summary');
    if (sm && !sm.parentNode.open) place(sm.parentNode);
    var close = t.closest('[data-pf-close]');
    if (close) {
      var d = close.closest('details');
      if (d) d.removeAttribute('open');
      return;
    }
    var link = t.closest('[data-pl] a[data-pf-link], .pf-dock a[data-pf-link]');
    if (link && !e.metaKey && !e.ctrlKey) {
      e.preventDefault();
      replace(link.href, true);
      return;
    }
    var mb = t.closest('[data-pl] a[data-pl-more]');
    if (mb && !e.metaKey && !e.ctrlKey) {
      e.preventDefault();
      more(mb);
      return;
    }
    /* clicar fora fecha os menus de filtro */
    document.querySelectorAll('[data-pl] details[data-pf-d][open], .pf-dock details[data-pf-d][open]').forEach(function (d) {
      if (!d.contains(t)) d.removeAttribute('open');
    });
  });

  /* o cartão do filtro nasce da própria pílula: mede a pílula e posiciona o cartão no .pf */
  /* o filtro abre num balão logo abaixo da pílula, com a largura dela (mínimo para caber as opções) */
  function place(d) {
    var pf = d.closest('.pf-dock') || d.closest('.pf'), sm = d.querySelector('summary'), pop = d.querySelector('.pf__pop');
    if (!pf || !sm || !pop) return;
    var b = pf.getBoundingClientRect(), r = sm.getBoundingClientRect();
    var w = Math.max(r.width, d.classList.contains('pf__d--sort') ? 212 : 136);
    var x = r.left - b.left;
    if (x + w > b.width) x = Math.max(0, b.width - w);
    if (x < 0) x = 0;
    pop.style.setProperty('--pf-x', Math.round(x) + 'px');
    pop.style.setProperty('--pf-y', Math.round(r.bottom - b.top + 6) + 'px');
    pop.style.setProperty('--pf-w', Math.round(w) + 'px');
    /* o balão nasce do meio da pílula */
    pop.style.setProperty('--pf-ox', Math.round(r.left - b.left - x + r.width / 2) + 'px');
    pop.classList.toggle('is-narrow', w < 190);
  }
  function shutAll() {
    document.querySelectorAll('[data-pl] details[data-pf-d][open], .pf-dock details[data-pf-d][open]').forEach(function (o) { o.removeAttribute('open'); });
  }
  /* a fileira rolou de lado: o balão acompanha a pílula; só fecha se a pílula saiu da fileira */
  document.addEventListener('scroll', function (e) {
    var row = e.target;
    if (!row.classList || !row.classList.contains('pf__row')) return;
    var d = row.querySelector('details[data-pf-d][open]');
    if (!d) return;
    var rb = row.getBoundingClientRect(), sb = d.querySelector('summary').getBoundingClientRect();
    if (sb.right < rb.left + 8 || sb.left > rb.right - 8) d.removeAttribute('open');
    else place(d);
  }, true);

  /* ---------- pílulas que "entram" no cabeçalho ----------
     Quando o menu (aba branca fixa) passa por cima da fileira de filtros, a fileira sai da página e vai
     para uma faixa presa embaixo da aba: aba + faixa viram um cartão só (uma sombra, cantos de 12px).
     Um espaço do mesmo tamanho fica no lugar, para a página não pular. Ao voltar, a fileira volta. */
  var dock = null, hold = null, dockRaf = 0;
  function hcTab() { return document.querySelector('[data-hc-tab]'); }
  function ensureDock() {
    if (dock) return dock;
    dock = document.createElement('div');
    dock.className = 'pf pf-dock';
    dock.setAttribute('aria-label', 'Filtros');
    document.body.appendChild(dock);
    return dock;
  }
  function docked() { return !!(dock && dock.querySelector('.pf__row')); }
  function undock() {
    if (!docked()) return;
    shutAll();
    var row = dock.querySelector('.pf__row');
    if (hold && hold.parentNode) hold.parentNode.replaceChild(row, hold);
    else row.remove();
    hold = null;
    dock.classList.remove('is-on');
    var html = document.documentElement;
    html.classList.remove('pl-docked');
    /* a sombra da aba volta na hora (sem a transição do tema), senão ela some e reaparece */
    html.classList.add('pl-dock-x');
    clearTimeout(undock._t);
    undock._t = setTimeout(function () { html.classList.remove('pl-dock-x'); }, 360);
    undock.at = Date.now();
  }
  function dockSync() {
    dockRaf = 0;
    var tab = hcTab(), r0 = root();
    var hc = tab && tab.closest('.hc');
    if (!tab || !r0 || !hc) return;
    var stuck = hc.hasAttribute('data-stuck') && !(hc.getAttribute('data-open'));
    var tr = tab.getBoundingClientRect();
    if (docked()) {
      /* volta quando o lugar original da fileira desce para baixo da aba (ou o menu abriu algo) */
      var hr = hold && hold.getBoundingClientRect();
      /* folga de 24px para não ficar entrando e saindo no limite (rolagem rápida) */
      if (!stuck || !hold || !hold.isConnected || hr.bottom > tr.bottom + 24) { undock(); return; }
      place2(tr);
      return;
    }
    var row = r0.querySelector('.pf__row');
    if (!row || !stuck) return;
    var rr = row.getBoundingClientRect();
    if (rr.bottom > tr.bottom) return;
    /* entra: guarda o lugar e leva a fileira para a faixa */
    shutAll();
    hold = document.createElement('div');
    hold.className = 'pf__hold';
    hold.style.height = row.offsetHeight + 'px';
    row.parentNode.replaceChild(hold, row);
    var d = ensureDock();
    d.appendChild(row);
    row.scrollLeft = 0;
    place2(tr);
    document.documentElement.classList.add('pl-docked');
    d.classList.remove('is-on', 'is-quiet');
    void d.offsetWidth;
    /* saiu e voltou há pouco (rolagem rápida): entra sem animação */
    if (undock.at && Date.now() - undock.at < 600) d.classList.add('is-quiet');
    d.classList.add('is-on');
    follow(Date.now() + 700);
  }
  /* a aba do menu ainda pode estar deslizando (desktop): acompanha por um instante */
  function follow(until) {
    requestAnimationFrame(function () {
      var tab = hcTab();
      if (!docked() || !tab) return;
      place2(tab.getBoundingClientRect());
      if (Date.now() < until) follow(until);
    });
  }
  function place2(tr) {
    dock.style.left = Math.round(tr.left) + 'px';
    dock.style.width = Math.round(tr.width) + 'px';
    dock.style.top = Math.round(tr.top) + 'px';
    dock.style.setProperty('--pf-tab-h', Math.round(tr.height) + 'px');
  }
  function dockLater() { if (!dockRaf) dockRaf = requestAnimationFrame(dockSync); }
  window.addEventListener('scroll', dockLater, { passive: true });
  window.addEventListener('resize', function () { undock(); dockLater(); });
  /* o cabeçalho muda de estado (abre busca/sacola/menu): reavalia */
  if ('MutationObserver' in window) {
    var watchHc = function () {
      var hc = document.querySelector('.hc');
      if (hc) new MutationObserver(dockLater).observe(hc, { attributes: true, attributeFilter: ['data-open', 'data-stuck'] });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchHc); else watchHc();
  }
  window.addEventListener('resize', shutAll);

  /* um menu de filtro aberto por vez */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!(d instanceof HTMLDetailsElement) || !d.matches('[data-pf-d]') || !d.open) return;
    place(d);
    document.querySelectorAll('[data-pl] details[data-pf-d][open], .pf-dock details[data-pf-d][open]').forEach(function (o) {
      if (o !== d) o.removeAttribute('open');
    });
  }, true);

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('[data-pl] form[data-pf-form], .pf-dock form[data-pf-form]')) return;
    e.preventDefault();
    var fd = new FormData(f);
    if (e.submitter && e.submitter.name) fd.set(e.submitter.name, e.submitter.value);
    var u = new URL(f.action, location.origin);
    fd.forEach(function (v, k) { if (v !== '') u.searchParams.append(k, v); });
    replace(u.toString(), true);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var d = document.querySelector('[data-pl] details[data-pf-d][open], .pf-dock details[data-pf-d][open]');
    if (d) {
      d.removeAttribute('open');
      var s = d.querySelector('summary');
      if (s) s.focus();
    }
  });

  window.addEventListener('popstate', function () {
    if (root()) replace(location.href, false);
  });
})();
